import { AsyncPipe, CommonModule, DatePipe } from "@angular/common";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { ToastModule } from "primeng/toast";
import { filter, map, Observable, Subscription } from "rxjs";
import { HeaderComponent } from "./components/header/header.component";
import { User } from "./interfaces/user/user.model";
import { AuthService } from "./services/auth.service";
@Component({
    selector: "app-root",
    imports: [RouterOutlet, HeaderComponent, CommonModule, AsyncPipe, ToastModule],
    providers: [MessageService, ConfirmationService, DialogService, DatePipe],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.css",
})
export class AppComponent implements OnInit, OnDestroy {
    title: string = "";
    subtitle: string = "";
    subscription = new Subscription();

    activeUser$: Observable<User | null> = this.authService.activeUser$;

    constructor(private router: Router, private route: ActivatedRoute, private authService: AuthService) {}

    ngOnInit() {
        this.authService.me();
        this.subscription.add(
            this.router.events
                .pipe(
                    filter((event) => event instanceof NavigationEnd),
                    map(() => {
                        let child = this.route.firstChild;
                        while (child?.firstChild) {
                            child = child.firstChild;
                        }
                        const routeData = child?.snapshot.data;
                        return {
                            title: routeData?.["title"],
                            subtitle: routeData?.["subtitle"],
                        };
                    })
                )
                .subscribe((data: { title: string; subtitle: string }) => {
                    this.title = data.title;
                    this.subtitle = data.subtitle;
                })
        );
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
